import { MapMatchQuality } from './mapmatchquality';
import { MapMatchSubPoint } from './mapmatchsubpoint.model';

export class MapMatchQualityPoint extends MapMatchQuality {
  public readonly lng: number;
  public readonly lat: number;
  public readonly mainroad: number;
  public readonly hasPositive: boolean;
  public readonly hasNegative: boolean;
  public subPoints: MapMatchSubPoint[];

  static getBbox(point: MapMatchQualityPoint): [number, number][] {
    // From subpoints lng and lat
    // find the smallest lat, biggest lat, smallest lng, biggest lng
    // To [[sLat, sLng], [bLat, bLng]]
    // To [[51.2476, 3.8574], [51.3178, 4.0658]]

    const p = 0.001;

    if (point.subPoints && point.subPoints.length > 0) {
      let minLat = 999;
      let maxLat = 0;
      let minLng = 999;
      let maxLng = 0;

      for (const sp of point.subPoints) {
        if (sp.lat !== null || sp.lng != null) {
          if (sp.lat < minLat) {
            minLat = sp.lat;
          }
          if (sp.lat > maxLat) {
            maxLat = sp.lat;
          }

          if (sp.lng < minLng) {
            minLng = sp.lng;
          }
          if (sp.lng > maxLng) {
            maxLng = sp.lng;
          }
        } else {
          if (point.lat < minLat) {
            minLat = point.lat;
          }
          if (point.lat > maxLat) {
            maxLat = point.lat;
          }

          if (point.lng < minLng) {
            minLng = point.lng;
          }
          if (point.lng > maxLng) {
            maxLng = point.lng;
          }
        }
      }

      return [
        [minLat - p, minLng - p],
        [maxLat + p, maxLng + p]
      ];
    } else {
      return [
        [point.lat - p, point.lng - p],
        [point.lat + p, point.lng + p]
      ];
    }
  }

  static copy(mmqp: MapMatchQualityPoint): MapMatchQualityPoint {
    const subPoints: MapMatchSubPoint[] = [];

    for (const sp of mmqp.subPoints) {
      subPoints.push(MapMatchSubPoint.copy(sp));
    }

    return {
      vildVersionId: mmqp.vildVersionId,
      vildLocNr: mmqp.vildLocNr,
      quality: mmqp.quality,
      lng: mmqp.lng,
      lat: mmqp.lat,
      mainroad: mmqp.mainroad,
      hasPositive: mmqp.hasPositive,
      hasNegative: mmqp.hasNegative,
      subPoints
    };
  }
}

/*
{
    vildVersionId: 1,
    vildLocNr: 7009,
    quality: 0.0,
    lng: 4.963193955693767,
    lat: 52.35231834868577,
    mainroad: 3000,
    subPoints: [
        {
            subPoint: "END_NEG",
            osmId: 253037034,
            offset: 278
        },
        {
            subPoint: "END_POS",
            osmId: 253038842,
            offset: 689
        },
        {
            subPoint: "START_NEG",
            osmId: 253037034,
            offset: 1178
        },
        {
            subPoint: "START_POS",
            osmId: 243558380,
            offset: 783
        }
    ]
}
*/



// WEBPACK FOOTER //
// ./src/app/models/mapmatchqualitypoint.model.ts